import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccountInfoActions } from 'projects/money-movement-ui/src/app/account-info-header/actions';
import { selectFilteredWiresStandingAuth, selectInfo, selectNraIndicator, selectStateCode } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { ReviewPageActions } from 'projects/money-movement-ui/src/app/create-request/actions';
import { getProcessDateInIsoFormat } from 'projects/money-movement-ui/src/app/create-request/components/transactions-table/table-helpers';
import {
  WireExtraPrompts, WireForm, WireTransactionDetails,
  isWireForm
} from 'projects/money-movement-ui/src/app/create-request/models/form/TransactionForm';
import {
  selectStagedTransactionForm,
  selectUseStandingAuth,
  selectWireCountries,
  selectWireInfo,
  selectTwePopupIndicator
} from 'projects/money-movement-ui/src/app/create-request/reducers';
import { currencyStringToNumber } from 'projects/money-movement-ui/src/app/create-request/utilities/currencyStringToNumber';
import { selectIsStandingAuthViewPage, selectViewDetails } from 'projects/money-movement-ui/src/app/transaction-view/reducers';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedActions } from '../../../actions';
import { FormatDatePipe } from '../../../pipes/FormatDatePipe';
import { selectEAuthInfo, selectViewInContext } from '../../../reducers';
import {
  Constants,
  YesNo,
  amountTypeDict,
  pdfLabelsSubmitDetails,
  pdfLabelsToDetails,
  recipientType,
  transactionDetailLabels,
  transactionTypes,
  transactionTypesDict,
  yesNo,
  pageInContext
} from '../../../utilities/Constants';
import { FormatIsoAddressFieldsService } from '../../../services/format-isoAddressFields.service';
import { Country } from 'projects/money-movement-ui/src/app/create-request/models/shared/Country';
import { CountryDescriptionFromCode } from '../../../utilities/CountryDescriptionFromCode';
import { selectInitReleaseTransactionsByDraftIdCallSuccess, selectSloaDataForTransactionBeingReleased } from 'projects/money-movement-ui/src/app/initiate-and-release/reducers';
import { MONTH_LIST } from 'projects/money-movement-ui/src/app/create-request/models/wire/MonthList';

@Component({
  standalone: false,
  selector: 'mm-transaction-details-section-wire-iso',
  templateUrl: './transaction-details-section-wire-iso.component.html',
  styleUrls: ['./transaction-details-section-wire-iso.component.scss'],
})
export class TransactionDetailsSectionWireIsoComponent implements OnInit {
  @Input() isInrFromTable: boolean;
  readonly labels = transactionDetailLabels;
  readonly wireDisclaimer: string = Constants.wireReviewPageDisclaimer;
  readonly taxParagraphOne: string = Constants.taxCopyParagraphOne;
  readonly taxParagraphTwo: string = Constants.taxCopyParagraphTwo;
  readonly pdfLabelsToDetails = pdfLabelsToDetails;
  readonly pdfLabelsSubmitDetails = pdfLabelsSubmitDetails;
  transactionTypeLabel: string = transactionTypesDict[transactionTypes.wire];
  createRequestStep$: Observable<string>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  useStandingAuth: 'yes' | 'no' | 'bundled' | '';
  standingAuthDetails: string[];
  transactionDetails: WireTransactionDetails;
  receivingBankDetails: string[];
  receivingAccountHolder: string[];
  isFirstParty: boolean;
  wireFee: string;
  totalWithdrawalAmount: string;
  isEscrow: boolean;
  recipient: string;
  recipientName: string[];
  recipientAddress: string[];
  intermediarySelection: string;
  intermediaryInstitutionName: string[];
  intermediaryAccountNumber: string;
  intermediaryDetails: string[];
  creditToSelection: string;
  creditToInstitutionName: string[];
  creditToAccountNumber: string;
  creditToDetails: string[];
  isIra: boolean;
  isPtrs: boolean;
  fedTaxPercent: string;
  fedTaxAmount: string;
  stateTaxPercent: string;
  stateTaxAmount: string;
  grossAmount: string;
  netAmount: string;
  distributionReason: string;
  amountIncludingTaxesLabel: string;
  amountIncludingTaxes: string;
  wireAmount: string;
  trustTaxCode: string;
  trustIncmPct: string;
  trustPrinPct: string;
  tranMemo: string;
  paidFor: string;
  trustTaxCat: string;
  useSloa: boolean;
  isFedWire: boolean;
  isViewPage: boolean = false;
  isStandingAuthViewPage: boolean = false;
  labelRefNum: string;
  refNum: string;
  viewPagePtrsInfoBannerPrimaryText = Constants.viewPagePtrsInfoBannerPrimaryText;
  viewPagePtrsInfoBannerBoldText = Constants.viewPagePtrsInfoBannerBoldText;
  isViewTemplate: boolean = false;
  formatDatePipe = new FormatDatePipe();
  formattedSelectDate: string;
  isBundledStandingAuthTransaction: boolean;
  showForeignCurrencyFields: boolean = false;
  currencyAmount: string;
  currencyType: string;
  exchangeRate: string;
  stateTaxLabel: string = this.labels.stateTax;
  useSloaIntermediaryAccountNumberLabel: string;
  intermediaryBIC: string;
  intermediaryClearingSysId: string;
  receivingBankClearingSysId: string | null;
  useSloaSecondIntermediaryAccountNumberLabel: string;
  secondIntermediaryAccountNumber: string;
  secondIntermediaryBIC: string;
  secondIntermediaryClearingSysId: string;
  secondIntermediaryDetails: string[];
  useSloaThirdIntermediaryAccountNumberLabel: string;
  thirdIntermediaryAccountNumber: string;
  thirdIntermediaryBIC: string;
  thirdIntermediaryClearingSysId: string;
  thirdIntermediaryDetails: string[];
  useFiveColumns: boolean = false;
  isThreeStep: boolean = false;
  isFourStep: boolean = false;
  receivingBankAbaHeader: string = 'ABA number';
  useSloa$: Observable<boolean>;
  countryList$: Observable<Country[]>;
  countryListDropdown: { value:string, name:string }[];
  isIdentifierAba: boolean;
  isoReceivingBankAccountNumber: string = this.labels.isoReceivingBankAccountNumber;
  isIrsAba: boolean = false;
  transmissionNotesLabel: string = this.labels.wireTransmissionNotes;
  palAgreementAcknowledgement: string = '';
  palAgreementItems: string[] = [];
  taxMonth: string = '';
  taxPayerId: string;
  taxTypeCode: string;
  taxYear: string;
  taxMonthCode: string;
  irsAdditionalInfo: string;
  pdfTransmissionNotesLoa: string = pdfLabelsSubmitDetails.additionalWireInstructions;
  federalReferenceNumberDisclaimer: string = Constants.federalReferenceNumberDisclaimer;
  private hasUpdatedExtendedDate: boolean = false;

  constructor(private store: Store, private formatIsoAddressFieldsService: FormatIsoAddressFieldsService) { }

  ngOnInit(): void {
    combineLatest([
      this.store.select(selectStagedTransactionForm),
      this.store.select(selectWireInfo),
      this.store.select(selectInfo),
      this.store.select(selectFilteredWiresStandingAuth),
      this.store.select(selectViewInContext),
      this.store.select(selectIsStandingAuthViewPage),
      this.store.select(selectEAuthInfo),
      this.store.select(selectViewDetails),
      this.store.select(selectInitReleaseTransactionsByDraftIdCallSuccess),
      this.store.select(selectSloaDataForTransactionBeingReleased),
      this.store.select(selectTwePopupIndicator)
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([form, wireInfo, info, standingAuth, step, standingAuthView, eauthInfo, viewDetails, draftCallSuccess, sloaAccountData, openTwePopup]) => {
        if (isWireForm(form)) {
          this.isBundledStandingAuthTransaction = form.extraPrompts.useBundledStandingAuth === 'yes';
          this.transactionTypeLabel = this.getTransactionTypeLabel(form.extraPrompts);
          this.useStandingAuth = this.getStandingAuthValue(form.extraPrompts);
          let selectedAuthorization = form.extraPrompts.standingAuthId?.split('-')[1];
          let selectedStandingAuthorization = standingAuth.find( auths => auths.cashieringRqstId === selectedAuthorization);
          if (viewDetails.type === 'template') {
            this.isViewTemplate = true;
          }
          if (step === pageInContext.view || step === pageInContext.viewMsv) {
            this.isViewPage = true;
            if (wireInfo.isBsloaTransaction && standingAuthView) this.transactionTypeLabel = 'Wire - bundled'
          }
          if (selectedStandingAuthorization && !this.isViewPage) {
            this.standingAuthDetails = [
              selectedStandingAuthorization.nickname,
              selectedStandingAuthorization.to1,
              selectedStandingAuthorization.to2,
              selectedStandingAuthorization.to3,
              selectedStandingAuthorization.address
            ]
          }
          this.countryList$ = this.store.select(selectWireCountries);
          this.countryList$?.pipe(takeUntil(this.destroy$)).subscribe((countries) => {
            this.countryListDropdown = countries.map((country) => {
              return { value: country.code, name: country.description };
            });
          });
          this.isStandingAuthViewPage = standingAuthView;
          // transactionDetails is from immutable NgRx state, and the component was mutating it, so need to create a copy of it here to avoid that mutation
          this.transactionDetails = { ...form.transactionDetails };
          this.isIrsAba = wireInfo?.isIrsAba;
          this.pdfTransmissionNotesLoa = this.isIrsAba ? this.pdfLabelsSubmitDetails.transmissionNotesIrs : this.pdfLabelsSubmitDetails.additionalWireInstructions;
          this.transmissionNotesLabel = this.isIrsAba ? this.labels.wireIrsTransmissionNotes : this.labels.wireTransmissionNotes;
          this.palAgreementAcknowledgement = wireInfo?.palAgreementAcknowledgement ?? '';
          const palAgreementText = wireInfo?.palAgreementText ?? '';
          this.palAgreementItems = palAgreementText ? palAgreementText.split(/\s*-\s+/).map((s: string) => s.trim()).filter((s: string) => s.length > 0) : [];
          this.taxMonth = ((MONTH_LIST.filter(x => x.code === this.transactionDetails.taxMonth)[0]?.description || '') + ' ' + this.getNonEmptyTaxMonth(this.transactionDetails.taxMonth));
          if(this.isViewPage && this.isIrsAba){
            this.taxPayerId = wireInfo.taxRemittance.taxId;
            this.taxTypeCode = wireInfo.taxRemittance.taxTypeCode;
            this.taxYear = wireInfo.taxRemittance.taxYear;
            this.taxMonthCode = wireInfo.taxRemittance.taxMonthCode;
            this.irsAdditionalInfo = wireInfo.taxRemittance.additionalInfo;
            this.transactionDetails.transmissionNotes = ''; // Clear transmission notes from transaction details to avoid duplication
          }
          this.taxMonthCode = ((MONTH_LIST.filter(x => x.code === this.taxMonthCode)[0]?.description || '') + ' ' + this.getNonEmptyTaxMonth(this.taxMonthCode));
          this.formattedSelectDate = this.formatDatePipe.transform(wireInfo?.processDate ?? '');
          if (wireInfo.processDateFields.isExtendedProcessingWindow
            && wireInfo.processDateFields.useExtendedProcessDates
            && eauthInfo?.isOptedOut
            && step === pageInContext.confirmation
            && !this.hasUpdatedExtendedDate) {
              const selectedDate = new Date(getProcessDateInIsoFormat(this.transactionDetails.selectedDate));
              const extendedDate = new Date(getProcessDateInIsoFormat(wireInfo.processDateFields.extendedProcessDates[0]));
              if (extendedDate.toDateString() === selectedDate.toDateString()) {
                this.hasUpdatedExtendedDate = true;
                this.store.dispatch(SharedActions.updateSelectedDate({newDate: wireInfo.processDateFields.standardProcessDates[0]}));
                this.transactionDetails.selectedDate = wireInfo.processDateFields.standardProcessDates[0];
              }
            }
          this.isEscrow = form.transactionDetails.isEscrow;
          this.isFedWire = wireInfo.isFedWire;
          this.useSloa = form.extraPrompts.useStandingAuth.toLowerCase() === 'yes' || form.extraPrompts.useBundledStandingAuth === 'yes' ? true : false;
          this.useSloa$ = this.store.select(selectUseStandingAuth);
          this.recipient = this.determineRecipient(form.transactionDetails.recipient);
          this.isFirstParty = form.transactionDetails.recipient === recipientType.firstParty;
          const isRenderISOProperties  = (form.transactionDetails?.isISOCompliant) || !this.useSloa;
          if(isRenderISOProperties) {
            this.receivingBankDetails = 
            [
              form.transactionDetails?.receivingBankName,
              form.transactionDetails?.receivingBankCity + ' ' + form.transactionDetails?.receivingBankState,
              CountryDescriptionFromCode(form.transactionDetails?.receivingBankCountry, this.countryListDropdown)
            ];
          } else {
            this.receivingBankDetails = [
              form.transactionDetails?.receivingBankName1 + ' ' + (form.transactionDetails?.receivingBankName2 ?? ''),
              form.transactionDetails?.receivingBankAddress1 + ' ' + (form.transactionDetails?.receivingBankAddress2 ?? ''),
              form.transactionDetails?.receivingBankCountry
            ];
          }
          this.isIdentifierAba = form.transactionDetails?.receivingBankIdentifierList?.[0]?.identifierType === 'USABA';
          let recipientIdentifierList = this.isViewPage ? wireInfo?.receivingAccountHolderIdentifierList : form.transactionDetails?.receivingAccountHolderIdentifierList;
          this.isoReceivingBankAccountNumber = recipientIdentifierList?.[0]?.identifierType?.toLowerCase() === 'iban' ? 
                                                this.labels.isoReceivingIBAN : this.labels.isoReceivingBankAccountNumber;
          if (!this.isViewPage || draftCallSuccess){
            this.receivingBankClearingSysId = !this.isIdentifierAba ? form.transactionDetails.receivingBankClearingSysId : null;
          }
          else if(this.isViewPage){
            this.receivingBankClearingSysId = !this.isIdentifierAba ? wireInfo.receivingBankClearingSysId : null;
          }
          // Set ABA number label based on ISO compliance and country
          if ((this.useSloa && form.transactionDetails?.isISOCompliant)) {
            const country = form.transactionDetails?.receivingBankCountry?.toUpperCase();
            if (country === 'US' || country === 'UNITED STATES') {
              this.labels.abaNumber = Constants.abaNumber;
            } else {
              this.labels.abaNumber = transactionDetailLabels.intermediaryUseSloaBicBankDetails;
            }
          } else {
            this.labels.abaNumber = Constants.abaNumber;
          }
          if (this.useSloa && (this.isViewPage || draftCallSuccess)) {
            this.standingAuthDetails = (draftCallSuccess && sloaAccountData) ?  [ 
              sloaAccountData?.nickName ?? '' ,
              sloaAccountData?.to1 ?? '',
              sloaAccountData?.to2 ?? '',
              sloaAccountData?.to3 ?? '',
              sloaAccountData?.address1 ?? ''
            ] : [
              wireInfo.nickname ?? "",
              form.transactionDetails.receivingBankName1,
              form.transactionDetails.receivingBankName2,
              form.transactionDetails.toAccount
            ]
          }

          this.intermediarySelection =
            form.transactionDetails.intermediarySelection;
          this.intermediaryInstitutionName = [
            form.transactionDetails.intermediaryName,
            form.transactionDetails.intermediaryNameCont,
          ];
          this.receivingBankAbaHeader = wireInfo?.isFedWire ? this.receivingBankAbaHeader : 'Business ID code (BIC)';
          const country = form.transactionDetails.intermediaryCountry == "US" ? "UNITED STATES" : form.transactionDetails.intermediaryCountry;
          //Intermediary Use Sloa
          this.intermediaryAccountNumber =
            (form.transactionDetails?.intermediaryAccountNumber) ? form.transactionDetails?.intermediaryAccountNumber :
            ((form.transactionDetails?.intermediaryIBAN) ? form.transactionDetails?.intermediaryIBAN : '');
          this.intermediaryBIC = form.transactionDetails?.intermediaryBIC;
          this.intermediaryClearingSysId = form.transactionDetails?.intermediaryClearingSysId;
          this.useSloaIntermediaryAccountNumberLabel = this.setAccountLabel(form.transactionDetails?.intermediaryIBAN);
          const intermediaryCountry = form.transactionDetails?.intermediaryCountry?.length == 2 ? CountryDescriptionFromCode(form.transactionDetails?.intermediaryCountry, this.countryListDropdown): form.transactionDetails?.intermediaryCountry;
          const secondIntermediaryCountry = form.transactionDetails?.secondIntermediaryCountry?.length == 2 ? CountryDescriptionFromCode(form.transactionDetails?.secondIntermediaryCountry, this.countryListDropdown): form.transactionDetails?.secondIntermediaryCountry;
          const thirdIntermediaryCountry = form.transactionDetails?.thirdIntermediaryCountry?.length == 2 ? CountryDescriptionFromCode(form.transactionDetails?.thirdIntermediaryCountry, this.countryListDropdown): form.transactionDetails?.thirdIntermediaryCountry;
          
          this.intermediaryDetails = isRenderISOProperties ? this.formatAddress(form.transactionDetails.intermediaryName, form.transactionDetails.intermediaryStreetNumber, form.transactionDetails.intermediaryStreetName, form.transactionDetails.intermediaryApartmentSuiteEtc, form.transactionDetails.intermediaryDepartment, form.transactionDetails.intermediaryBuildingName, form.transactionDetails.intermediaryFloor, form.transactionDetails.intermediaryTownLocationName, form.transactionDetails.intermediaryCity, form.transactionDetails.intermediaryDistrict, form.transactionDetails.intermediaryState, form.transactionDetails.intermediaryZip, intermediaryCountry) :
                                     this.formatNonIsoAddress(form.transactionDetails?.intermediaryName, form.transactionDetails?.intermediaryNameCont, form.transactionDetails?.intermediaryAddress, form.transactionDetails?.intermediaryAddressCont, form.transactionDetails?.intermediaryCountry, form.transactionDetails?.intermediaryPhone);
          //Second Intermediary Use Sloa
          this.isThreeStep = form.transactionDetails?.isThreeStep;
          this.secondIntermediaryAccountNumber =
            (form.transactionDetails?.secondIntermediaryAccountNumber) ? form.transactionDetails?.secondIntermediaryAccountNumber :
            ((form.transactionDetails?.secondIntermediaryIBAN) ? form.transactionDetails?.secondIntermediaryIBAN : '');
          this.secondIntermediaryBIC = form.transactionDetails?.secondIntermediaryBIC;
          this.secondIntermediaryClearingSysId = form.transactionDetails?.secondIntermediaryClearingSysId;
          this.secondIntermediaryDetails = isRenderISOProperties ? this.formatAddress(form.transactionDetails?.secondIntermediaryName ?? '', form.transactionDetails.secondIntermediaryStreetNumber, form.transactionDetails.secondIntermediaryStreetName, form.transactionDetails.secondIntermediaryApartmentSuiteEtc, form.transactionDetails.secondIntermediaryDepartment, form.transactionDetails.secondIntermediaryBuildingName, form.transactionDetails.secondIntermediaryFloor, form.transactionDetails.secondIntermediaryTownLocationName, form.transactionDetails.secondIntermediaryCity, form.transactionDetails.secondIntermediaryDistrict, form.transactionDetails.secondIntermediaryState, form.transactionDetails.secondIntermediaryZip, secondIntermediaryCountry) :
            this.formatNonIsoAddress(form.transactionDetails?.creditToName, form.transactionDetails?.creditToNameCont, form.transactionDetails?.creditToAddress, form.transactionDetails?.creditToAddressCont, form.transactionDetails?.creditToCountry, form.transactionDetails?.creditToPhone);
          this.useSloaSecondIntermediaryAccountNumberLabel = this.setAccountLabel(form.transactionDetails?.secondIntermediaryIBAN);

          //Third Intermediary Use Sloa
          this.isFourStep = form.transactionDetails?.isFourStep;
          this.thirdIntermediaryAccountNumber =
            (form.transactionDetails?.thirdIntermediaryAccountNumber) ? form.transactionDetails?.thirdIntermediaryAccountNumber :
            ((form.transactionDetails?.thirdIntermediaryIBAN) ? form.transactionDetails?.thirdIntermediaryIBAN : '');
          this.thirdIntermediaryBIC = form.transactionDetails?.thirdIntermediaryBIC;
          this.thirdIntermediaryClearingSysId = form.transactionDetails?.thirdIntermediaryClearingSysId;
          this.thirdIntermediaryDetails = this.formatAddress(form.transactionDetails?.thirdIntermediaryName ?? '', form.transactionDetails.thirdIntermediaryStreetNumber, form.transactionDetails.thirdIntermediaryStreetName, form.transactionDetails.thirdIntermediaryApartmentSuiteEtc, form.transactionDetails.thirdIntermediaryDepartment, form.transactionDetails.thirdIntermediaryBuildingName, form.transactionDetails.thirdIntermediaryFloor, form.transactionDetails.thirdIntermediaryTownLocationName, form.transactionDetails.thirdIntermediaryCity, form.transactionDetails.thirdIntermediaryDistrict, form.transactionDetails.thirdIntermediaryState, form.transactionDetails.thirdIntermediaryZip, thirdIntermediaryCountry);
          this.useSloaThirdIntermediaryAccountNumberLabel = this.setAccountLabel(form.transactionDetails?.thirdIntermediaryIBAN);
        
          // if all three properties Account number, BIC, and clearing sys ID are present then the width has to change as there will be 5 columns now instead of 4
          // so for changing the width on UI we need the below conditions
          if((this.intermediaryAccountNumber && this.intermediaryBIC && this.intermediaryClearingSysId) ||
              (this.secondIntermediaryAccountNumber && this.secondIntermediaryBIC && this.secondIntermediaryClearingSysId) ||
              (this.thirdIntermediaryAccountNumber && this.thirdIntermediaryBIC && this.thirdIntermediaryClearingSysId)) {
            this.useFiveColumns = true;
          }
          this.creditToSelection =
            form.transactionDetails.creditToSelection;
          this.creditToInstitutionName = [
            form.transactionDetails.creditToName,
            form.transactionDetails.creditToNameCont,
          ];
          this.creditToAccountNumber =
            form.transactionDetails.creditToAccountNumber;
          this.creditToDetails = [
            form.transactionDetails.creditToAddress?.toUpperCase(),
            form.transactionDetails.creditToAddressCont?.toUpperCase(),
            form.transactionDetails.creditToCountry,
            form.transactionDetails.creditToPhone,
          ];

          this.receivingAccountHolder = isRenderISOProperties ? this.formatAddress("", form.transactionDetails.receivingAccountHolderStreetNumber, form.transactionDetails.receivingAccountHolderStreetName, form.transactionDetails.receivingAccountHolderApartmentSuiteEtc, form.transactionDetails.receivingAccountHolderDepartment, form.transactionDetails.receivingAccountHolderBuildingName, form.transactionDetails.receivingAccountHolderFloor, form.transactionDetails.receivingAccountHolderTownLocationName, form.transactionDetails.receivingAccountHolderCity, form.transactionDetails.receivingAccountHolderDistrict, form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip, !!wireInfo.toDetails.beneficiaryCountry ? wireInfo.toDetails.beneficiaryCountry : form.transactionDetails.receivingAccountHolderCountry) : 
          [
            form.transactionDetails.receivingAccountHolderName1 + (form.transactionDetails?.receivingAccountHolderName2 == undefined ? '' : ' ') + (form.transactionDetails?.receivingAccountHolderName2 ?? ''),
            form.transactionDetails.receivingAccountHolderAddress1 + (form.transactionDetails?.receivingAccountHolderAddress2 == undefined ? '' : ' ') + (form.transactionDetails?.receivingAccountHolderAddress2 ?? ''),
            form.transactionDetails.receivingAccountHolderCountry
          ];

          this.recipientName = isRenderISOProperties ? [
            form.transactionDetails.name
          ] : [form.transactionDetails?.receivingAccountHolderName1 + (form.transactionDetails?.receivingAccountHolderName2 == undefined ? '' : ' ') + (form.transactionDetails?.receivingAccountHolderName2 ?? '')];
          const receipientCountry = !!wireInfo.toDetails.beneficiaryCountry ? wireInfo.toDetails.beneficiaryCountry : form.transactionDetails.receivingAccountHolderCountry;
          this.recipientAddress = isRenderISOProperties ?
            this.formatReceivingAccountHolderAddress(form, receipientCountry) :
            this.formatNonIsoAddress("", "", form.transactionDetails?.receivingAccountHolderAddress1, form.transactionDetails?.receivingAccountHolderAddress2, form.transactionDetails?.receivingAccountHolderCountry, "");

          this.wireFee = wireInfo.wireFee;

          if (step === pageInContext.view || step === pageInContext.viewMsv) {
            this.wireAmount = wireInfo.withdrawalAmount; // gross amount
            this.totalWithdrawalAmount = (
              currencyStringToNumber(this.wireFee) +
              currencyStringToNumber(this.wireAmount)
            ).toString();
            
            if (wireInfo.withdrawalAmount !== wireInfo.wireAmount || (currencyStringToNumber(wireInfo.fedTaxAmount) === 0 && currencyStringToNumber(wireInfo.stateTaxAmount) === 0)) {
              this.amountIncludingTaxesLabel = 'Net wire amount';
              this.amountIncludingTaxes = currencyStringToNumber(wireInfo.wireAmount).toString(); // net amount
            }
          } else {
            this.wireAmount = wireInfo.wireAmount;
            this.totalWithdrawalAmount = (
              currencyStringToNumber(this.wireFee) +
              currencyStringToNumber(wireInfo.wireAmount)
            ).toString();
  
            // IRA specific amount logic
            if (form.transactionDetails.amountType === amountTypeDict.gross) {
              this.wireAmount = wireInfo.withdrawalAmount;
  
              let withdrawalAmount = currencyStringToNumber(
                wireInfo.withdrawalAmount
              );
              this.amountIncludingTaxesLabel = 'Net wire amount';
              this.amountIncludingTaxes = (
                withdrawalAmount -
                currencyStringToNumber(wireInfo.fedTaxAmount) -
                currencyStringToNumber(wireInfo.stateTaxAmount)
              ).toString();
              this.totalWithdrawalAmount = (
                currencyStringToNumber(this.wireFee) + withdrawalAmount
              ).toString();
            } else if (
              form.transactionDetails.amountType === amountTypeDict.net
            ) {
              let withdrawalAmount = currencyStringToNumber(wireInfo.wireAmount);
              this.amountIncludingTaxes = (
                withdrawalAmount +
                currencyStringToNumber(wireInfo.fedTaxAmount) +
                currencyStringToNumber(wireInfo.stateTaxAmount)
              ).toString();
              this.amountIncludingTaxesLabel = 'Gross wire amount';
              this.totalWithdrawalAmount = (
                currencyStringToNumber(this.wireFee) + +this.amountIncludingTaxes
              ).toString();
            }
          }

          this.fedTaxAmount = wireInfo.fedTaxAmount;
          this.stateTaxAmount = wireInfo.stateTaxAmount;

          if (this.isViewPage || info.classifications.isNraAccount) {
            this.fedTaxPercent = wireInfo.fedTaxPercent ?? '';
            this.stateTaxPercent = wireInfo.stateTaxPercent ?? '';
          }
          else {
            this.fedTaxPercent = form.transactionDetails.taxWithholdingsFormGroup?.fedTaxPercent ?? '';
            this.stateTaxPercent = form.transactionDetails.taxWithholdingsFormGroup?.stateTaxPercent ?? '';
          }

          this.distributionReason = wireInfo.distributionReasonDescription ?? '';

          if (step === pageInContext.confirmation) {
            this.labelRefNum = Constants.federalReferenceNumber;
            this.refNum = Constants.pending;
            if (openTwePopup) {
              this.store.dispatch(AccountInfoActions.updateHeaderTaxRates({
                federalTaxRate: this.fedTaxPercent,
                stateTaxRate: this.stateTaxPercent
              }));
            }
          } else {
            this.labelRefNum = form.transactionDetails.labelRefNum;
            this.refNum = form.transactionDetails.refNum;
          }

          this.showForeignCurrencyFields = this.isViewPage && 
            Object.values(wireInfo?.foreignCurrencyFields).some(x => this.isNotEmptyOrNull(x));
          if (this.showForeignCurrencyFields) {
            this.currencyAmount = wireInfo?.foreignCurrencyFields?.currencyAmount;
            this.currencyType = wireInfo?.foreignCurrencyFields?.currencyType;
            this.exchangeRate = wireInfo?.foreignCurrencyFields?.exchangeRate;
          }
        }

        this.isIra = info.classifications.isIra;
        this.isPtrs = info.classifications.isPtrs;

        // Trust fields only
        if (this.isPtrs) {
          this.trustIncmPct = form.transactionDetails.trustIncomePercent ?? '';
          this.trustPrinPct = form.transactionDetails.trustPrincipalPercent ?? '';
          this.trustTaxCode = form.transactionDetails.trustTaxCode ?? '';
          this.paidFor = form.transactionDetails.trustPaidFor ?? '';
          this.tranMemo = form.transactionDetails.trustComment ?? '';
          this.trustTaxCat = form.transactionDetails.trustTaxCategory ?? '';
        }
      });

    this.createRequestStep$ = this.store.select(selectViewInContext);

    combineLatest([
      this.store.select(selectStateCode),
      this.store.select(selectNraIndicator)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([stateCode, nraIndicator]) => {
      if (stateCode && !nraIndicator) {
        this.stateTaxLabel = `${this.labels.stateTax} (${stateCode})`;
      }
    });
  }

  getNonEmptyTaxMonth(taxMonth: string): string {
    if(taxMonth === undefined || taxMonth === null || taxMonth.trim() === '') {
      return '';
    } else {
      return '('+ taxMonth + ')';
    }
  }
  

  // Formatting and merging receiving account holder address which includes adding ',' only if next field is present which is optional.
  formatReceivingAccountHolderAddress(form: WireForm, receipientCountry: string) : string[] {
    let receivingAccountHolderAdress = [];
    receivingAccountHolderAdress.push(
      this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderStreetNumber ? form.transactionDetails.receivingAccountHolderStreetNumber + " " + form.transactionDetails.receivingAccountHolderStreetName : form.transactionDetails.receivingAccountHolderStreetName) +
      (this.formatIsoAddressFieldsService.getNextLine(form.transactionDetails.receivingAccountHolderStreetNumber ? form.transactionDetails.receivingAccountHolderStreetNumber + " " + form.transactionDetails.receivingAccountHolderStreetName : form.transactionDetails.receivingAccountHolderStreetName)) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderApartmentSuiteEtc, form.transactionDetails.receivingAccountHolderDepartment, form.transactionDetails.receivingAccountHolderBuildingName, form.transactionDetails.receivingAccountHolderFloor) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderDepartment, form.transactionDetails.receivingAccountHolderBuildingName, form.transactionDetails.receivingAccountHolderFloor) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderBuildingName, form.transactionDetails.receivingAccountHolderFloor) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderFloor, "") +
    (this.formatIsoAddressFieldsService.getNextLine(form.transactionDetails.receivingAccountHolderApartmentSuiteEtc, form.transactionDetails.receivingAccountHolderDepartment, form.transactionDetails.receivingAccountHolderBuildingName, form.transactionDetails.receivingAccountHolderFloor)) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderTownLocationName, form.transactionDetails.receivingAccountHolderCity, form.transactionDetails.receivingAccountHolderDistrict, form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderCity, form.transactionDetails.receivingAccountHolderDistrict, form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderDistrict, form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip) +
    this.formatIsoAddressFieldsService.getFieldsValue(form.transactionDetails.receivingAccountHolderZip) +
     (this.formatIsoAddressFieldsService.getNextLine(form.transactionDetails.receivingAccountHolderTownLocationName, form.transactionDetails.receivingAccountHolderCity, form.transactionDetails.receivingAccountHolderDistrict, form.transactionDetails.receivingAccountHolderState, form.transactionDetails.receivingAccountHolderZip)) +
      this.formatIsoAddressFieldsService.getFieldsValue(receipientCountry) +
      this.formatIsoAddressFieldsService.getNextLine(receipientCountry))
    return receivingAccountHolderAdress;
  }

  formatNonIsoAddress(name1?: string, name2?: string, address1?: string, address2?: string, country?: string, phone?: string) {
    let address = [];
    address.push(
      this.formatIsoAddressFieldsService.getFieldsValue(name1, name2) +
      this.formatIsoAddressFieldsService.getFieldsValue(name2, "") +
      (this.formatIsoAddressFieldsService.getNextLine(name1, name2)) +
      this.formatIsoAddressFieldsService.getFieldsValue(address1, address2) +
      this.formatIsoAddressFieldsService.getFieldsValue(address2, "") +
      (this.formatIsoAddressFieldsService.getNextLine(address1, address2)) +
      this.formatIsoAddressFieldsService.getFieldsValue(country, "") +
      (this.formatIsoAddressFieldsService.getNextLine(country, "")) +
      phone
    );
    return address;
  }

  // Formatting and merging intermediary use sloa address which includes adding ',' only if next field is present which is optional.
  formatAddress(name?: string, streetNumber?:string, streetName?:string, apartmentSuiteEtc?:string, department?:string, buildingName?:string, floor?:string, townLocationName?:string, city?:string, district?:string, state?:string, zipCode?:string, beneficiaryCountry?:string): string[] {
    let intermediaryAddress = [];
    intermediaryAddress.push(this.formatIsoAddressFieldsService.getFieldsValue(name) +
    (this.formatIsoAddressFieldsService.getNextLine(name)) +
      this.formatIsoAddressFieldsService.getFieldsValue(streetNumber? streetNumber + " " + streetName:streetName) +
      (this.formatIsoAddressFieldsService.getNextLine(streetNumber ? streetNumber + " " + streetName : streetName)) +
    this.formatIsoAddressFieldsService.getFieldsValue(apartmentSuiteEtc, department, buildingName, floor) +
    this.formatIsoAddressFieldsService.getFieldsValue(department, buildingName, floor) +
    this.formatIsoAddressFieldsService.getFieldsValue(buildingName, floor) +
    this.formatIsoAddressFieldsService.getFieldsValue(floor, "") +
    (this.formatIsoAddressFieldsService.getNextLine(apartmentSuiteEtc, department, buildingName, floor)) +
    this.formatIsoAddressFieldsService.getFieldsValue(townLocationName, city, district, state, zipCode) +
    this.formatIsoAddressFieldsService.getFieldsValue(city, district, state, zipCode) +
    this.formatIsoAddressFieldsService.getFieldsValue(district, state, zipCode) +
    this.formatIsoAddressFieldsService.getFieldsValue(state, zipCode) +
    this.formatIsoAddressFieldsService.getFieldsValue(zipCode) +   
    this.formatIsoAddressFieldsService.getNextLine(townLocationName, city, district, state, zipCode) +
    this.formatIsoAddressFieldsService.getFieldsValue(beneficiaryCountry, "") +
    this.formatIsoAddressFieldsService.getNextLine(beneficiaryCountry) 
    );
    return intermediaryAddress;
  }

  setAccountLabel(iban: string | undefined | null) {
    return iban ? 'International account number (IBAN)' : 'Account number';
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onEditClicked(): void {
    this.store.dispatch(ReviewPageActions.editClicked());
  }

  determineRecipient(recipient: string): string {
    if (recipient === recipientType.firstParty) {
      return Constants.wireFirstParty;
    }
    if (this.isEscrow) {
      return Constants.wireThirdPartyEscrow;
    }
    return Constants.wireThirdParty
  }

  getTransactionTypeLabel(extraPrompts: WireExtraPrompts): string {
    let isBundledNonSloaTransaction = extraPrompts.useStandingAuth === 'bundled' && extraPrompts.useBundledStandingAuth !== 'yes';
    return isBundledNonSloaTransaction ? `${transactionTypesDict[transactionTypes.wire]} - bundled` : transactionTypesDict[transactionTypes.wire]; 
  }

  getStandingAuthValue(extraPrompts: WireExtraPrompts): YesNo | '' {
    if (extraPrompts.useStandingAuth === 'bundled'){
      if (extraPrompts.useBundledStandingAuth === 'yes') return yesNo.yes;
      if (extraPrompts.useBundledStandingAuth === 'no') return yesNo.no;
      return '';
    } 
    return extraPrompts.useStandingAuth;
  }

  isNotEmptyOrNull(param: any) {
    const params = param?.trim();
    if (params === null || params === undefined || params === 'undefined%' || params === '') {
      return false;
    }
    return true;
  }

  get pageHeader(): string {
    return this.isStandingAuthViewPage ? 'Standing authorization details' : 'Transaction details';
  }
}
